import { render, staticRenderFns } from "./UploadMediaFile.vue?vue&type=template&id=827b6a9e&scoped=true&"
import script from "./UploadMediaFile.vue?vue&type=script&lang=js&"
export * from "./UploadMediaFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadMediaFile.vue?vue&type=style&index=0&id=827b6a9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827b6a9e",
  null
  
)

export default component.exports